import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getCommentsV2QueryOptions } from '../api/queryOptions';

import { useUserScopedKey } from '@/hooks/useUserScopedQuery';

/** Refetches a post's thread now, resolving once it is back, for a caller that acts on the result. */
export function useRefetchComments() {
  const queryClient = useQueryClient();

  const commentsKey = useUserScopedKey(getCommentsV2QueryOptions);

  return useCallback(
    (postId: number) => queryClient.refetchQueries({ queryKey: commentsKey(postId) }),
    [queryClient, commentsKey]
  );
}
